import { render, staticRenderFns } from "./banding.vue?vue&type=template&id=3c190a5e&scoped=true"
import script from "./banding.vue?vue&type=script&lang=js"
export * from "./banding.vue?vue&type=script&lang=js"
import style0 from "./banding.vue?vue&type=style&index=0&id=3c190a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c190a5e",
  null
  
)

export default component.exports